<template>
  <div class="col custom-ivs-wizard">
    <ZTable v-model="ivsWizardItems" class="table table-bordered table-striped" :is-single-row-detail="false"
      :is-header-fixed="isHeaderFixed" :sort-by="line" :order-by="asc" :columns="tableColumns">
      <template #tbody="props">
        <td class="custom-column-60 text-center">{{ props.row.line }}</td>
        <td>{{ props.row.description }}</td>
        <td class="custom-column-60 text-center">{{ props.row.quantity }}</td>
        <td class="custom-column-110 text-right">
          {{ formatNumber(props.row.price, 2) }}
        </td>
      </template>
      <template #empty> Nothing found! </template>
    </ZTable>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { inspectionStore } from '@/stores/inspection'
import ZTable from '@/components/utilities/elements/Table.vue'
export default {
  name: "IvsWizard",
  components: {
    ZTable
  },
  data() {
    return {
      isHeaderFixed: true,
      message: null
    }
  },
  computed: {
    ...mapState(inspectionStore, ['inspection', 'ivsWizardItems']),
    tableColumns() {
      let columns = [
        { field: 'line', label: '#', sortable: false, class: 'custom-column-60 text-center' },
        { field: 'description', label: 'Description', sortable: false },
        { field: 'quantity', label: 'Qty', sortable: false, class: 'custom-column-60 text-center' },
        { field: 'price', label: 'Price', sortable: false, class: 'custom-column-110 text-right' }
      ]
      return columns
    }
  },
  methods: {
    formatNumber(value, decimals) {
      return parseFloat(value).toFixed(decimals)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-fit-consumables {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 620px;
  height: 98%;
}

.custom-fit-consumables-actions {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 40px;
  z-index: 10;
}

.custom-file-list {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 500px;
  width: 100%;
}

.custom-file-link {
  cursor: pointer;
  display: flex;
  align-items: left;

  a {
    padding: 10px;
    width: 100%;
  }
}
</style>